import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {XR} from '@react-three/xr';
import {Canvas} from '@react-three/fiber';
import {MeshType, useGetMesh} from 'api/generated';
import {useARStore} from 'stores';
import {xrStore} from 'lib';

import {ARCore} from './ar/core';
import {ARButtonEnter} from './ar/core/buttons';

interface IAndroid {
  style: React.CSSProperties;
  assignedMeshes: MeshType[];
  projectState: 'preview' | 'live';
}

const Android = ({style, assignedMeshes, projectState}: IAndroid) => {
  const [hasSession, setHasSession] = useState(false);
  const setMeshes = useARStore(s => s.setMeshes);
  const modelData = useARStore(s => s.modelData);

  const params = useParams();
  const projectParam = params.project ?? '';

  useGetMesh(
    modelData?.data?.uid ?? '',
    {state: projectState, slug: projectParam, token: projectParam},
    {query: {enabled: !!modelData?.data?.uid, staleTime: 60 * 1000}},
  );

  useEffect(() => {
    setMeshes(assignedMeshes);
  }, [assignedMeshes]);

  return (
    <>
      {!hasSession && <ARButtonEnter style={style} />}
      <Canvas shadows>
        <XR store={xrStore}>
          <ARCore onSessionChanged={setHasSession} />
        </XR>
      </Canvas>
    </>
  );
};

export default Android;
